import { useEffect, useRef, useState } from "react";

/** 0 dan `target` gacha silliq sanaydi (prefers-reduced-motion bo'lsa darhol ko'rsatadi). */
export function useCountUp(target: number | undefined, ms = 900): number | undefined {
  const [value, setValue] = useState<number | undefined>(undefined);
  const from = useRef(0);

  useEffect(() => {
    if (target === undefined) return;
    const reduce =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || typeof requestAnimationFrame !== "function") {
      const id = setTimeout(() => {
        setValue(target);
        from.current = target;
      }, 0);
      return () => clearTimeout(id);
    }
    const start = performance.now();
    const begin = from.current;
    let raf = 0;
    const tick = (now: number) => {
      const p = Math.min(1, (now - start) / ms);
      const eased = 1 - Math.pow(1 - p, 3);
      setValue(Math.round(begin + (target - begin) * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
      else from.current = target;
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, ms]);

  return value;
}
